import { queryOptions, useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { api } from '@/lib/api-client';
import { ReferralCode } from '@/types/api/sale';

const isNoCode = (error: unknown) =>
  isAxiosError(error) &&
  error.response?.status === 409 &&
  ['REFERRAL_PROGRAM_NOT_ACTIVE', 'SALE_NOT_ACTIVE'].includes(error.response.data?.error?.code);

/**
 * An active sale's referral code, created on the first call (the POST is idempotent). Null when no referral
 * program is running.
 */
export const getReferralCode = async ({ saleId }: { saleId: string }): Promise<ReferralCode | null> => {
  try {
    return (await api.post(`/sales/${saleId}/referral-code`)).data;
  } catch (error) {
    if (isNoCode(error)) return null;
    throw error;
  }
};

export const getReferralCodeQueryOptions = (saleId: string) => {
  return queryOptions({
    queryKey: ['sales', saleId, 'referral-code'],
    queryFn: () => getReferralCode({ saleId }),
  });
};

export const useReferralCode = ({ saleId, enabled = true }: { saleId: string; enabled?: boolean }) => {
  return useQuery({ ...getReferralCodeQueryOptions(saleId), enabled });
};
